function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9999 21H4.03993M10.0419 17.885L20.3219 7.60499C21.1029 6.82399 21.1029 5.55799 20.3219 4.77699L19.1999 3.65399C18.4189 2.87299 17.1529 2.87299 16.3719 3.65399L6.09093 13.935C5.94493 14.081 5.82293 14.249 5.72793 14.432L3.09793 19.528C2.65193 20.393 3.57893 21.321 4.44393 20.876L9.54293 18.25C9.72793 18.154 9.89593 18.032 10.0419 17.885ZM5.90993 14.19L9.78993 18.07L5.90993 14.19Z",
  stroke: "#3A3A3A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgPencilEdit = function SvgPencilEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPencilEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pencil-edit.ba8f173b.svg";
export { ForwardRef as ReactComponent };